export default "__VITE_ASSET__Czt0nrdP__"